module.exports = __webpack_public_path__ + "static/media/mayhem-in-action.9bbfbfc7.jpg";